import React from 'react';

import { IPortalLinkedTask } from '@interfaces/portal/tasks';

import {
	finishToFinishDefinitionText,
	finishToStartDefinitionText,
	startToFinishDefinitionText,
	startToStartDefinitionText,
	taskLinkTypesNames,
	taskLinkTypesTitles,
} from '@components/ModalComponents/TaskForm/LinkTasksForm/constants';

export const getLinkedTasksGroups = (linkedTasks: IPortalLinkedTask[]) => {
	return [
		{
			title: taskLinkTypesTitles.finishToStart.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.finishToStart && !task.isPredecessor;
			}),
			typeDefinitionText: (
				<>
					<b>{taskLinkTypesTitles.finishToStart}</b> {finishToStartDefinitionText}
				</>
			),
		},
		{
			title: taskLinkTypesTitles.finishToStartInward.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.finishToStart && task.isPredecessor;
			}),
		},
		{
			title: taskLinkTypesTitles.finishToFinish.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.finishToFinish && !task.isPredecessor;
			}),
			typeDefinitionText: (
				<>
					<b>{taskLinkTypesTitles.finishToFinish}</b> {finishToFinishDefinitionText}
				</>
			),
		},
		{
			title: taskLinkTypesTitles.finishToFinishInward.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.finishToFinish && task.isPredecessor;
			}),
		},
		{
			title: taskLinkTypesTitles.startToStart.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.startToStart && !task.isPredecessor;
			}),
			typeDefinitionText: (
				<>
					<b>{taskLinkTypesTitles.startToStart}</b> {startToStartDefinitionText}
				</>
			),
		},
		{
			title: taskLinkTypesTitles.startToStartInward.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.startToStart && task.isPredecessor;
			}),
		},
		{
			title: taskLinkTypesTitles.startToFinish.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.startToFinish && !task.isPredecessor;
			}),
			typeDefinitionText: (
				<>
					<b>{taskLinkTypesTitles.startToFinish}</b> {startToFinishDefinitionText}
				</>
			),
		},
		{
			title: taskLinkTypesTitles.startToFinishInward.toUpperCase(),
			linkedTasks: linkedTasks.filter(task => {
				return task.type.name === taskLinkTypesNames.startToFinish && task.isPredecessor;
			}),
		},
	];
};
